import { getURLWithParams } from '@viveaesthetics/shared-domain'

import { useGetClientPublicProfileAsync } from '@/hooks/useGetClientPublicProfile'
import { useRouter } from '@/hooks/useRouter'
import { ROUTES } from '@/constants/routes'
import { getUrlWithPersistedParams } from '@/utils/providers'
import { InsurancesEnum, StatesEnum } from '@/types/providers'
import { useParams } from '@/hooks/useParams'

export const useProviderBookButtonSubmit = ({
  providerId,
  domain
}: {
  providerId: string
  domain: string
}) => {
  const router = useRouter()

  const getClientPublicProfileAsync = useGetClientPublicProfileAsync()

  const { cash_payment, insurance, insuranceId } = useParams<{
    cash_payment: string
    insuranceId: string
    insurance: string
  }>()
  const redirectBasedOnPublicClientInfo = async (data: {
    timeSlot: Date
    email: string
    state: StatesEnum
  }) => {
    const publicProfile = await getClientPublicProfileAsync(data.email)
    if (publicProfile?.error) return

    if (!publicProfile || publicProfile?.data.clientNotFound) {
      router.push(
        getUrlWithPersistedParams(
          getURLWithParams({
            url: ROUTES.BOOKING,
            params: {
              email: data.email,
              therapist_id: providerId,
              time_slot: data.timeSlot?.toISOString(),
              state: data.state
            }
          })
        )
      )

      return
    }

    const url = new URL(`https://${domain}/login`)
    url.searchParams.set('therapist_id', providerId)
    if (data.email) url.searchParams.set('email', data.email)
    if (data.timeSlot)
      url.searchParams.set('time_slot', data.timeSlot?.toISOString())

    if (
      !insuranceId &&
      (insurance === InsurancesEnum.CASH || cash_payment || !insurance)
    ) {
      url.searchParams.set('cash_payment', 'true')
    }
    window.location.assign(url.toString())
  }

  return { redirectBasedOnPublicClientInfo }
}
